import { Form } from "@/react/components/shared/uikit/Form";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { Header } from "../../components/Header";

interface HeaderFormProps {
  titleLocale: string;
  toggleName: string;
}

export const HeaderForm = ({ titleLocale, toggleName }: HeaderFormProps) => (
  <Header className="flex flex-row items-center justify-between px-6 py-4">
    <Typography.LabelSm weight="semibold">{titleLocale}</Typography.LabelSm>
    <Form.ToggleSwitch name={toggleName} variant="large" />
  </Header>
);
